import { Heart, Target, Sparkles } from "lucide-react";

const About = () => {
  return (
    <section className="py-24 w-full">
      <div className="container mx-auto px-4 md:px-8">
        {/* Main Heading */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-6xl font-extrabold text-tasktide-dark dark:text-white mb-6 leading-tight">
            Empowering African Businesses to Thrive
          </h2>
          <p className="text-gray-500 dark:text-gray-400 text-lg max-w-3xl mx-auto font-medium">
            OptiBiz Suite is a comprehensive, cloud-based business management platform specifically designed to address the unique challenges faced by African enterprises, SMEs, and NGOs.
          </p>
        </div>

        {/* Three Pillars: Mission, Vision, Values */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-20">
          {/* Mission */}
          <div className="bg-white dark:bg-gray-800 rounded-[2.5rem] p-10 border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 transition-colors">
            <div className="w-16 h-16 rounded-2xl bg-tasktide-blue/10 dark:bg-tasktide-blue/20 flex items-center justify-center text-tasktide-blue mb-6">
              <Target size={32} />
            </div>
            <h3 className="text-2xl font-bold text-tasktide-dark dark:text-white mb-4">Our Mission</h3>
            <p className="text-gray-500 dark:text-gray-400 text-md font-medium leading-relaxed">
              To empower African businesses with world-class technology that drives efficiency and growth.
            </p>
          </div>

          {/* Vision */}
          <div className="bg-white dark:bg-gray-800 rounded-[2.5rem] p-10 border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 transition-colors">
            <div className="w-16 h-16 rounded-2xl bg-tasktide-green/10 dark:bg-tasktide-green/20 flex items-center justify-center text-tasktide-green mb-6">
              <Sparkles size={32} />
            </div>
            <h3 className="text-2xl font-bold text-tasktide-dark dark:text-white mb-4">Our Vision</h3>
            <p className="text-gray-500 dark:text-gray-400 text-md font-medium leading-relaxed">
              To be the leading business management platform across Africa and beyond.
            </p>
          </div>

          {/* Values */}
          <div className="bg-white dark:bg-gray-800 rounded-[2.5rem] p-10 border border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 transition-colors">
            <div className="w-16 h-16 rounded-2xl bg-tasktide-orange/10 dark:bg-tasktide-orange/20 flex items-center justify-center text-tasktide-orange mb-6">
              <Heart size={32} />
            </div>
            <h3 className="text-2xl font-bold text-tasktide-dark dark:text-white mb-4">Our Values</h3>
            <p className="text-gray-500 dark:text-gray-400 text-md font-medium leading-relaxed">
              Innovation, customer focus, excellence, and accessibility in everything we do.
            </p>
          </div>
        </div>
      </div>


    </section>
  );
};

export default About;
